import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { orderBy } from 'lodash';
import AgentCard from '../../components/AgentCard';

const styles = css`
  padding: 58px 20px 100px;
  @media (min-width: 360px) {
    padding-left: 27px;
    padding-right: 27px;
  }
  @media (min-width: 768px) {
    padding: 88px 40px 120px;
  }
  @media (min-width: 992px) {
    padding: 116px 90px 150px;
  }
  @media (min-width: 1440px) {
    padding-left: 135px;
    padding-right: 135px;
  }
  .AgentsList_inner {
    max-width: 600px;
    margin: 0 auto;
    @media (min-width: 768px) {
      max-width: 1600px;
    }
  }
  .AgentsList_cardsWrapper {
    margin-bottom: -85px;
    @media (min-width: 768px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding-top: 35px;
      margin-left: -20px;
      margin-right: -20px;
    }
    @media (min-width: 768px) {
      margin-bottom: -125px;
    }
    @media (min-width: 1280px) {
      margin-left: -25px;
      margin-right: -25px;
    }
  }
  .AgentCard {
    margin-bottom: 64px;
    @media (min-width: 768px) {
      margin: 0 20px 125px;
    }
    @media (min-width: 1280px) {
      margin-left: 25px;
      margin-right: 25px;
    }
  }
`;


function AgentsList({ agents }) {
  const sortedAgents = orderBy(agents, 'name');
  return (
    <div className={styles}>
      <div className="AgentsList_inner">
        <div className="AgentsList_cardsWrapper">
          {
            sortedAgents
              .filter(agent => agent.include_on_list)
              .map(agent => (<AgentCard agent={agent} key={agent._id} />))
          }
        </div>
      </div>
    </div>
  );
}

AgentsList.propTypes = {
  agents: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData({
  agents: true,
})(AgentsList);



// WEBPACK FOOTER //
// ./src/pages/Agents/List.js